'use client';

import React from 'react';
import { Layout } from '@benzinga/core-ui';
import { MoneyPage } from '@benzinga/money';
import type { WordpressPage } from '@benzinga/content-manager';

const DefaultSidebar = React.lazy(() => import('../Sidebars/DefaultSidebar'));

interface CryptoBitcoinContentProps {
  page: WordpressPage | null;
}

export function CryptoBitcoinContent({ page }: CryptoBitcoinContentProps) {
  return (
    <Layout
      layoutSidebar={
        <React.Suspense>
          <DefaultSidebar sidebar={page?.sidebar} />
        </React.Suspense>
      }
      layoutMain={page ? <MoneyPage page={page} showTitle={false} /> : <div />}
    />
  );
}
